export default "/institutions/amex.svg";